import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'get'

export default class OspreyImagesSearch extends BaseAction {
    constructor(dataKey) {
        const id = '63bd8a8c-b506-4bf3-bb81-168a094bfabc'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'archived,created,expiration,id,images,language,marketingCategory,modified,name,shareTo,tags,thumbnailUrl,ownerOrn',
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-search.js